'use client';
import {
  Button,
  CardPricing,
  Image,
  Typography,
} from '@curology/ui-components-web';
import { convertSchemaToHtml } from '@thebeyondgroup/shopify-rich-text-renderer';

import '../css/carousel.css';

import { useProduct } from '@/utils/shopify/hooks/useProduct';
import { useProductVariant } from '@/utils/shopify/hooks/useProductVariant';

import { formatMoneyV2 } from '../utils/money';

const ProductRadioOption = ({
  productId,
  defaultVariantId,
  onChange,
}: {
  productId: string;
  defaultVariantId: string;
  onChange: () => void;
}) => {
  const { displayTitle, shortDescription, dialogHero } = useProduct(productId);
  const { productVariant } = useProductVariant(defaultVariantId);

  return (
    <div className="cur-px-4 cur-py-2 cur-flex cur-justify-between cur-items-center cur-bg-white">
      {dialogHero && (
        <Image
          alt={dialogHero.altText || 'Hero image'}
          aspectRatio="2:3"
          className="cur-w-[125px] cur-flex-shrink-0"
          src={dialogHero.url}
        />
      )}
      <div className="cur-ml-4">
        <Typography
          size="h3"
          dangerouslySetInnerHTML={{
            __html: displayTitle || productVariant.title,
          }}
        />
        {shortDescription && (
          <Typography
            className="cur-mt-2"
            size="body"
            dangerouslySetInnerHTML={{
              __html: convertSchemaToHtml(shortDescription),
            }}
          />
        )}
        <CardPricing
          className="cur-mr-1"
          price={formatMoneyV2({
            amount: productVariant.compareAtPrice ?? productVariant.price,
          })}
          salePrice={formatMoneyV2({ amount: productVariant.price })}
        />
        <div className="cur-flex cur-w-full cur-justify-end cur-mt-2">
          <Button onClick={() => onChange()} type="button">
            Choose
          </Button>
        </div>
      </div>
    </div>
  );
};

export { ProductRadioOption };
